import React from 'react';
import {
  SubmitButton,
  ButtonColor,
} from 'ui-builder';
import useClientPortalService, { DomainDto } from './clientPortalService';
import FormTemplate from '../../../shared/uibuilder/form/FormTemplate';
import Text from '../../../shared/uibuilder/form/input/Text';
import { useDataLoaderNew } from 'data-loader';
import LoadingAnimation from '../../../shared/LoadingAnimation';

export default function ClientPortalConfigurationForm() {
  const service = useClientPortalService();

  const { data: currentDomain, refreshData } = useDataLoaderNew(service.getDomain);

  if (currentDomain) {
    return (
      <FormTemplate<DomainDto>
        submitFormFunc={async (data) => {
          if (data.subdomain !== currentDomain?.subdomain) {
            const result = await service.updateDomain(data.subdomain);
            refreshData(); // Refresh data from server

            return result;
          } else {
            return data;
          }
        }}
        initialData={currentDomain}
        validationSchema={{
          subdomain: {
            type: 'string',
            constraints: {
              required: true,
              minLength: 4,
              maxLength: 15,
              regex: {
                value: /^[0-9a-z]+$/g,
              },
            },
          },
        }}
        buttons={
          <SubmitButton text="Update" color={ButtonColor.YELLOW} />
        }
      >
        <div>
          You current client portal URL is
          {' '}
          {`${currentDomain.subdomain}.nekst.com.`}
        </div>
        <Text
          source="subdomain"
          label="Client Portal Subdomain"
          hint="Minimum 4 characters. Use only lowercase letters (a-z) and numbers (0-9). No spaces or special characters."
        />
        <div style={{ color: '#f2ab30' }}>
          Please be aware, altering this URL will invalidate all previously shared client portal
          links.
        </div>
      </FormTemplate>
    );
  } else {
    return <LoadingAnimation />;
  }
}
